import React, { useState, useEffect } from "react";
import { Route, Routes, Navigate } from "react-router-dom";
import Home from "./Home";
import ProductsList from "./ProductsList.js";
import Articles from "./Articles";
import About_us from "./About_us";
import Callus from "./Callus";
import Product from "./Product";
import Admin from "./Admin.js";
import Register from "./Register.js";
import Login from "./Login.js";
import CartPage from "./CartPage.js";
import BatteryMaintenanceArticle from "./articles/Article1";
import BadBatteryArticle from "./articles/Article2";
import TopBatteriesArticle from "./articles/Article3";
import OrderPrint from "./OrderPrint";
import ProductContextProvider from "./context/ProductContextProvider"; // Import ProductContextProvider
import AdminLogin from "./Panel/AdminLogin";
import AdminDashboard from "./Panel/AdminDashboard";
const App = () => {
  // یک پرچم ساده برای بررسی وضعیت ورود
  const [isAdminLoggedIn, setIsAdminLoggedIn] = useState(
    localStorage.getItem("isAdminLoggedIn") === "true"
  );

  useEffect(() => {
    // اطمینان از همگام بودن وضعیت با localStorage
    const storedLoginStatus =
      localStorage.getItem("isAdminLoggedIn") === "true";
    if (storedLoginStatus !== isAdminLoggedIn) {
      setIsAdminLoggedIn(storedLoginStatus);
    }
  }, [isAdminLoggedIn]); // این وابستگی را نگه دارید تا تغییرات localStorage را رصد کند

  return (
    <>
      <Routes>
        <Route path="/" Component={Home} />
        <Route path="/محصولات/" Component={ProductsList} />
        <Route path="/مقالات/" Component={Articles} />
        <Route path="/تماس باما/" Component={Callus} />
        <Route path="/درباره ما/" Component={About_us} />
        {/* Wrap the Product route with ProductContextProvider */}
        <Route
          // Change the path to use productSlug
          path="/product/:productSlug"
          element={
            <ProductContextProvider>
              <Product />
            </ProductContextProvider>
          }
        />
        <Route path="/مدیریت/" Component={Admin} />
        <Route path="/تکمیل خرید/" Component={Register} />
        <Route path="/ورود/" Component={Login} />
        <Route path="/سبد خرید/" Component={CartPage} />
        <Route path="/مقالات/1/" Component={BatteryMaintenanceArticle} />
        <Route path="/مقالات/2/" Component={BadBatteryArticle} />
        <Route path="/مقالات/3/" Component={TopBatteriesArticle} />
        <Route path="/چاپ سفارش/" Component={OrderPrint} />
        <Route
          path="/admin"
          element={<AdminLogin setIsAdminLoggedIn={setIsAdminLoggedIn} />}
        />
        <Route
          path="/admin/dashboard"
          element={
            isAdminLoggedIn ? ( // چک کردن پرچم
              <AdminDashboard
                isAdminLoggedIn={isAdminLoggedIn}
                setIsAdminLoggedIn={setIsAdminLoggedIn}
              />
            ) : (
              <Navigate to="/admin" replace />
            )
          }
        />
      </Routes>
    </>
  );
};

export default App;
